import {MainRequest} from 'Services/common';

const UrlMap = {
    list: '/aichat/mcp',
    detail: '/aichat/mcp/get',
    edit: '/aichat/mcp/save',
    remove: '/aichat/mcp/del',
};

export namespace Mcp {
    export type QueryForm = {
        code?: string; //        MCP Server编码，唯一标识
        name?: string; //        Server名称
        description?: string; //        Server描述
        baseUrl?: string; //        基础URL
    };

    export interface Schema {
        code: string; //        MCP Server编码，唯一标识
        name: string; //        Server名称
        description: string; //        Server描述
        baseUrl: string; //        基础URL
        status: boolean; //        状态：0-禁用，1-启用
    }

    export interface List extends Schema {
        id: string;
    }

    export interface Detail extends Schema {
        id: string;
    }

    export interface Form extends Schema {
        id?: string;
    }

    export type QueryList = QueryForm;
}

export class Mcp {
    static list(data: Mcp.QueryList) {
        return MainRequest.post<SuccessData<Mcp.List[]>>(UrlMap.list, {
            data,
        })
            .then(res => res.data.data)
            .then(res => {
                return {
                    total: res?.length,
                    data: res,
                };
            });
    }

    static async detail(id: string) {
        return MainRequest.get<SuccessData<Mcp.Detail>>(
            `${UrlMap.detail}/${id}`,
        ).then(res => res.data.data);
    }

    static async save(data: Mcp.Form) {
        return MainRequest.post(UrlMap.edit, data);
    }

    static async remove(id: string) {
        return MainRequest.get(`${UrlMap.remove}/${id}`);
    }

    static FieldType = ['string', 'int', 'float', 'boolean', 'json', 'array'];
    static FieldTypeOptions = Mcp.FieldType.map(item => {
        return {
            label: item,
            value: item,
        };
    });

    static HttpPosition = ['query', 'header', 'body', 'path'] as const;
    static HttpPositionOptions = Mcp.HttpPosition.map(item => {
        return {
            label: item,
            value: item,
        };
    });
}
